import { Component, OnInit } from '@angular/core';
import { FormBuilder, Validators } from '@angular/forms';
import { Router } from '@angular/router';
import { LoginService } from 'src/app/shared/services/login.service';

@Component({
  selector: 'app-forgot-password',
  templateUrl: './forgot-password.component.html',
  styleUrls: ['./forgot-password.component.scss']
})


export class ForgotPasswordComponent implements OnInit {
  public error: boolean = false;
  public errMsg: string = '';
  public isValid: boolean = false;
  public email: string = '';
  public redirectURL: string = '';

  PasswordForm = this.fb.group({
    userEmail: [null, Validators.required]
  })

  constructor(
    private loginService: LoginService,
    private router: Router,
    private fb: FormBuilder,
  ) { }

  ngOnInit() {
  }
  onDataSubmit() {
    this.isValid = true;
    this.error = false;
    this.email = this.PasswordForm.controls.userEmail.value;
    if (this.email === null || this.email === undefined || this.email.length === 0) {
      this.error = true;
      this.errMsg = 'Username/Email is required.';
      this.isValid = false;
    }

    if (this.isValid) {
      this.forgotPassword();
    }
  }

  forgotPassword() {
    let jsonData =
    {
      'email': this.email,
        'site': 'RC3'
    };

    this.loginService.initiateForgotPassword(jsonData).subscribe(() => {
        window.scrollTo(0, 0);
        alert('If the information you have provided matches an active profile, please check your email for directions to continue accessing the site. If you continue to have issues, call 860.563.1223 or call info@reimbursementcodes.com.');
        this.router.navigate(['/login']);
    }, () => {
      this.error = true;
      this.errMsg = 'Unable to send email. If you continue to have issues, call 860.563.1223 or call info@reimbursementcodes.com.';
    });
  }
}
